<template>
  <main class="container-fluid pb_50 createDetail">
    <section class="segment pt_12">
      <template>
        <!-- 外溢保單提示資訊 -->
        <div
          class="w-100 text-danger insuredInfo__text mb_10"
          v-if="isSpillover"
        >
          外溢保單重要提醒!!<br />
          本建議書商品具健康外溢回饋機制，須綁定「FitBack健康吧」健康計畫，請引導客戶下載國泰人壽APP並綁定健康計畫，以免損及客戶權益。
          (綁定教學與外溢回饋內容詳見建議書內頁)
        </div>
      </template>
      <!-- 要被保人資訊 -->
      <InsuredInfo />
      <!-- 保費明細頁面 -->
      <components :is="currentMode" />
    </section>
    <!-- 替換契約預警(無ID沒有) -->
    <section
      class="segment mb_30"
      v-if="replace_show == true && MfViewing.inputType == 'family'"
    >
      <h4 class="text-green mt_15 mb_10">替換契約預警</h4>
      <div class="contractWarning">
        <div class="contractWarning__title">
          查詢日期:{{ today.year }}年{{ today.mon }}月{{ today.date }}日
        </div>
        <div
          class="contractWarning__item"
          v-for="(item, index) in replace_policy_list"
          :key="item.insured_id + index"
        >
          <div class="contractWarning__item__insured">
            被保險人:
            <Avatar
              class="mr_5"
              :gender="Number(item.insured_gender)"
              :size="20"
              :height="20"
            />
            <!-- hover身分證、生日 -->
            <Tooltip
              position="top"
              :id="item.insured_id.indexOf('~') > -1 ? '' : item.insured_id"
              :birthday="formatDate(item.insured_birthday)"
            >
              <div class="font-20 breakLine text-left text-underline">
                {{ truncate(item.insured_name, 12) }}
              </div>
            </Tooltip>

            <span class="d-flex mr_3 ml_3"></span>
            年齡:{{ item.insured_age }}歲(

            <span v-if="item.insured_birthday != ''">{{
              formatDate(item.insured_birthday) | getMaskBirthday
            }}</span>
            <span v-else>/ /</span>
            ) 身分證:
            <span
              v-if="item.insured_id == '' || item.insured_id.indexOf('~') > -1"
            >
              --</span
            >
            <span v-else>{{ item.insured_id | getMaskID }}</span>
          </div>
          <div class="contractWarning__item__queryRes">
            <div>近180天是否曾辦理/發生主約解約、停效等情形:</div>
            <div>
              {{
                replace_policy_map[item.insured_id]
                  ? replace_policy_map[item.insured_id].main_result
                  : "未輸入身分證故無法查詢"
              }}
            </div>
          </div>
          <div class="contractWarning__item__queryRes">
            <div>近180天是否曾辦理/發生附約解約、停效等情形:</div>
            <div>
              {{
                replace_policy_map[item.insured_id]
                  ? replace_policy_map[item.insured_id].rider_result
                  : "未輸入身分證故無法查詢"
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="contractWarningRmk mt_3">
        諮詢窗口:保單行政部保單服務整合科<br />
        說明:<br />
        1.本查詢結果僅供參考，實際交易情形仍以各項保全、保費交易紀錄為準。<br />
        2.資料日期：{{ `${today.year}/${today.mon}/${today.date}` }}。<br />
        3.上述資料僅提供同仁了解客戶契約狀況，若客戶曾於資料日期前180天內辦理/發生解約、繳清、展期、縮小保額及停效之情形，將以Y表示。<br />
        4.每次查詢紀錄皆會永久保存。<br />
      </div>
    </section>
    <FixedBottom>
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <router-link
            class="btn btn-default px_5 mr_10"
            to="/mf/query/queryDetail"
            >查詢其他建議書</router-link
          >
          <button
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="
              toCreate();
              updateClickDate(
                MfViewing.prod_idx,
                MfViewing.mc_prod_list[0].FEATURE_DATA.prod_type,
              );
            "
          >
            修改建議書
          </button>
          <div
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="featuresHandler('printProposal')"
          >
            列印建議書
          </div>
          <button
            v-if="is_crm == '1' && !this.$store.getters.IsDirectMarketingUser"
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="featuresHandler('importMobile')"
            :disabled="isIV && !$store.getters.IsInvMI"
          >
            匯入行動投保
          </button>
          <button
            v-if="is_crm == '1'"
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="featuresHandler('importInsurance')"
            :disabled="
              $store.getters.BuTest || (isIV && proposal_IV_SC_length === 0)
            "
          >
            匯入保單健檢
          </button>
        </div>
      </template>
    </FixedBottom>
  </main>
</template>

<script>
// import mockCreateDetail from "@/desktop/views/mf/mock/createDetail.json";
// import ItemTD from "@/desktop/views/mf/components/2.Query/2-1-1.CreateDetail/Item_TD.vue";
import Avatar from "@/desktop/components/Avatar";
import mf_Mixin from "@/desktop/views/mf/mixin";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import Tooltip from "@/desktop/components/ToolTip";
import InsuredInfo from "@/desktop/views/mf/components/InsuredInfo";
import CreateDetail_TD from "@/desktop/views/mf/components/2.Query/2-1-1.CreateDetail/CreateDetail_TD";
import CreateDetail_IV from "@/desktop/views/mf/components/2.Query/2-1-1.CreateDetail/CreateDetail_IV";

import _ from "lodash";
import moment from "moment";
export default {
  mixins: [mf_Mixin],
  components: {
    Avatar,
    FixedBottom,
    Tooltip,
    InsuredInfo,
    CreateDetail_TD,
    CreateDetail_IV,
  },
  data() {
    return {
      isEdit: false,
      currentMode: "CreateDetail_TD",
      replace_policy_map: {},
      replace_policy_list: [],
      today: {
        year: new Date().getFullYear() - 1911,
        mon: new Date().getMonth() + 1,
        date: new Date().getDate(),
      },
      replace_show: false,
      proposal_IV_SC_length: [], //投資型列表附約
    };
  },
  computed: {
    MfViewing() {
      return this.$store.getters.MfViewing;
    },
    is_crm() {
      return this.MfViewing.inputType == "noId" ? "0" : "1";
    },
    isIV() {
      return this.MfViewing.saveData.prod_type != "1";
    },
    isIUL() {
      return this.MfViewing.saveData.prod_type == "5";
    },
    isSpillover() {
      const mcProdList = this.$store.getters.MfViewing.mc_prod_list;
      const mcHasSpillover = mcProdList.some((mcProduct) => {
        return (
          mcProduct.FEATURE_DATA.cwp_level === "1" ||
          mcProduct.FEATURE_DATA.cwp_level === "2" ||
          mcProduct.FEATURE_DATA.is_spillover4 === "1"
        );
      });
      const scHasSpillover = mcProdList.some((mcProduct) => {
        return (
          mcProduct.sc_prod_list &&
          mcProduct.sc_prod_list.length > 0 &&
          mcProduct.sc_prod_list.some((scProduct) => {
            return (
              scProduct.cwp_level === "1" || scProduct.cwp_level === "2" || scProduct.is_spillover4 === "1"
            );
          })
        );
      });

      return mcHasSpillover || scHasSpillover;
    },

    // 空白建議書,id為空值
    insurerID() {
      return this.$store.getters.MfEditing.inputType === "noId"
        ? ""
        : this.$store.getters.MfEditing.insurer.insured_id;
    },
  },
  created() {
    //判斷投資與傳統
    if (!this.MfViewing.prod_idx) {
      return this.$router.replace("/mf/create");
    }
    this.currentMode =
      this.MfViewing.saveData.prod_type == "1"
        ? "CreateDetail_TD"
        : "CreateDetail_IV";
    this.init();
  },
  methods: {
    init() {
      //處理重新搜尋按鈕的相關參數
      this.$store.commit("update_queryDetailTarget", {
        is_crm: this.MfViewing.insurer.insured_id == "" ? "0" : "1",
        insured_id: this.MfViewing.insured.insured_id,
        prod_idx:
          this.MfViewing.insurer.insured_id == ""
            ? this.MfViewing.prod_idx
            : "",
        familyid:
          this.MfViewing.insurer.insured_id == ""
            ? ""
            : this.$store.getters.MemberList[0].familyid,
      });

      //替換預警契約
      if (
        this.MfViewing.insurer &&
        this.MfViewing.inputType == "family" &&
        !this.$store.getters.IsBankUser
      ) {
        this.queryInsdsReplacePolicy();
      }

      // 檢查投資料表是否有附約
      if (this.isIV) {
        let length = this.MfViewing.saveData.mc_prod_list[0].sc_prod_list
          ? this.MfViewing.saveData.mc_prod_list[0].sc_prod_list.length
          : 0;
        this.proposal_IV_SC_length = length;
      }
      //更新難字
      this.registerHanlink();
    },
    toCreate() {
      this.isEdit = true;
      this.$store.commit("update_MfEditing", _.cloneDeep(this.MfViewing));
      this.$router.push("/mf/create");
    },
    async featuresHandler(mode) {
      let mc_prod_list = this.MfViewing.saveData.mc_prod_list;
      for (let i = 0; i < mc_prod_list.length; i++) {
        let mc = mc_prod_list[i];
        this.MfViewing.saveData.isDividend =
          mc.prod_type == "1" && mc.life_pol_design_type !== "2"; //是否為分紅保單
        let insured_id = "";
        try {
          insured_id = this.$store.getters.MfEditing.insured.insured_id;
          //空白建議書無被保人ID會拋錯
        } catch (e) {}
        let message = (message = await this.checkProdWhiteList(
          mc.prod_id,
          insured_id,
        ));
        if (message != "") {
          this.canSave = true;
          return this.$toast.info({
            title: message,
          });
        }
      }
      let WarnText = "";

      if (!this.isIUL) {
        WarnText = this.insuredRiskWarnText(
          this.insurerID,
          "importMobile",
          mc_prod_list[0],
        ); // 匯入投保判斷風險屬性是否有文字
      }

      switch (mode) {
        case "printProposal":
          this.$store.commit("set_proRiskObj", mc_prod_list[0]),
            this.$router.push("/mf/printProposal");
          return;
        case "importMobile":
          // if (this.$store.getters.BuTest) return;
          if (this.isIV && WarnText !== "") {
            return this.$toast.info({
              title: this.insuredRiskWarnText(
                this.insurerID,
                "importMobile",
                mc_prod_list[0],
              ),
            });
          }
          return this.$router.push("/mf/importMobile");
        case "importInsurance":
          if (this.$store.getters.BuTest) return;
          return this.$router.push("/mf/importInsurance");
      }
    },
    //替換預警契約
    async queryInsdsReplacePolicy() {
      let replace_policy_set = new Set();
      let insured_id_set = new Set();

      //
      //無ID不顯示
      if (this.MfViewing.saveData.insured_id) {
        replace_policy_set.add(
          JSON.stringify({
            insured_id: this.MfViewing.saveData.insured_id,
            insured_name: this.MfViewing.saveData.insured_name,
            insured_birthday: this.MfViewing.saveData.insured_birthday || "",
            insured_age: this.MfViewing.saveData.insured_age,
            insured_gender: this.MfViewing.saveData.insured_gender,
          }),
        );
        if (this.MfViewing.saveData.insured_id.indexOf("~") == -1) {
          insured_id_set.add(this.MfViewing.saveData.insured_id);
        }
      }

      this.MfViewing.saveData.mc_prod_list.forEach((mc) => {
        mc.sc_prod_list.forEach((sc) => {
          //無ID不顯示
          if (sc.insured_id) {
            replace_policy_set.add(
              JSON.stringify({
                insured_id: sc.insured_id,
                insured_name: sc.insured_name,
                insured_birthday: sc.insured_birthday || "",
                insured_age: sc.insured_age,
                insured_gender: sc.insured_gender,
              }),
            );
            if (sc.insured_id.indexOf("~") == -1) {
              insured_id_set.add(sc.insured_id);
            }
          }
        });
      });
      this.replace_policy_list = [...replace_policy_set].map((data) =>
        JSON.parse(data),
      );
      let insured_id_list = [...insured_id_set];
      if (insured_id_list.length > 0) {
        let { replace_policy_map } =
          await this.$mfAPI.MFA0_2200__queryInsdsReplacePolicy({
            insured_id_list,
          });
        this.replace_policy_map = replace_policy_map;
        this.replace_show = true;
      } else {
        this.replace_show = true;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    //新增頁才做判斷
    if (to.path == "/mf/create") {
      if (this.isEdit) {
        //如果是修建議書則直接進去
        next();
      } else {
        //直接按頁籤需要帶入
        let MfViewing = this.$store.getters.MfViewing;
        if (MfViewing.inputType == "noId") return next();
        this.$store.commit(
          "update_MfEditing",
          _.cloneDeep({
            insurer: MfViewing.insurer,
            insured: MfViewing.insured,
            inputType: MfViewing.inputType,
            sameInsurer: MfViewing.sameInsurer,
          }),
        );
        next();
      }
    } else {
      next();
    }
  },
};
</script>

<style lang="scss" scoped>
.createDetail {
  .contractWarning {
    max-width: 580px;
    border-radius: 4px;
    border: solid 1px #53c480;
    &__title {
      padding: 12px 8px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      min-height: 50px;
    }
    &__item {
      &__insured {
        justify-content: flex-start !important;
        padding: 0 40px !important;
        border-top: solid 2px #53c480;
        border-bottom: solid 1px #53c480;
        background-color: #e5f6ec;
      }
      & > div {
        padding: 12px 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 700;
        min-height: 50px;
      }
      &__queryRes {
        padding: 0 24px !important;
        & > div:last-of-type {
          font-weight: 500;
          flex-grow: 1;
          text-align: center;
        }
      }
    }
  }
  .contractWarningRmk {
    padding-left: 0.7rem;
    font-size: 13px;
    font-weight: normal;
    line-height: 1.69;
    text-align: left;
    color: #323a45;
  }

  .insuredInfo {
    &__text {
      display: flex;
      align-items: center;
      font-size: 18px;
      width: 114px;
      font-weight: 700;
    }
  }
}
</style>
